import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetItemVariantsForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemVariantsForCatalogController.php
* @route '/api/item-catalog/{item}/variants'
*/
const GetItemVariantsForCatalogController = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemVariantsForCatalogController.url(args, options),
    method: 'get',
})

GetItemVariantsForCatalogController.definition = {
    methods: ["get","head"],
    url: '/api/item-catalog/{item}/variants',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetItemVariantsForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemVariantsForCatalogController.php
* @route '/api/item-catalog/{item}/variants'
*/
GetItemVariantsForCatalogController.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return GetItemVariantsForCatalogController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetItemVariantsForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemVariantsForCatalogController.php
* @route '/api/item-catalog/{item}/variants'
*/
GetItemVariantsForCatalogController.get = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemVariantsForCatalogController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetItemVariantsForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemVariantsForCatalogController.php
* @route '/api/item-catalog/{item}/variants'
*/
GetItemVariantsForCatalogController.head = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemVariantsForCatalogController.url(args, options),
    method: 'head',
})

export default GetItemVariantsForCatalogController